"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainMappings = exports.Chains = void 0;
/* eslint-disable no-unused-vars */
/**
 * Chains supported by tBTC v2 contracts.
 */
var Chains;
(function (Chains) {
    let Ethereum;
    (function (Ethereum) {
        Ethereum["Mainnet"] = "1";
        Ethereum["Sepolia"] = "11155111";
        Ethereum["Local"] = "1101";
    })(Ethereum = Chains.Ethereum || (Chains.Ethereum = {}));
    let Base;
    (function (Base) {
        Base["Base"] = "8453";
        Base["BaseSepolia"] = "84532";
    })(Base = Chains.Base || (Chains.Base = {}));
    let Arbitrum;
    (function (Arbitrum) {
        Arbitrum["Arbitrum"] = "42161";
        Arbitrum["ArbitrumSepolia"] = "421614";
    })(Arbitrum = Chains.Arbitrum || (Chains.Arbitrum = {}));
})(Chains = exports.Chains || (exports.Chains = {}));
/**
 * List of chain mappings supported by tBTC v2 contracts.
 */
exports.ChainMappings = [
    {
        ethereum: Chains.Ethereum.Mainnet,
        base: Chains.Base.Base,
        arbitrum: Chains.Arbitrum.Arbitrum,
    },
    {
        ethereum: Chains.Ethereum.Sepolia,
        base: Chains.Base.BaseSepolia,
        arbitrum: Chains.Arbitrum.ArbitrumSepolia,
    },
];
//# sourceMappingURL=chain.js.map